import { render, staticRenderFns } from "./jf-account-details.vue?vue&type=template&id=173ab017&lang=pug&"
import script from "./jf-account-details.vue?vue&type=script&lang=js&"
export * from "./jf-account-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports